import {appAPI} from '../../../api';

const alertPath = '/machinery-alert';

export const alertAPI = {
    markRead: async (ids: string[]): Promise<void> => {
        await appAPI.patch(`${alertPath}/read`, {ids});
    },
};